<section class="screening-shell" *ngIf="!vm.loading; else loadingState">
	<div class="screening-shell__bleed">
		<div class="c-section__header c-text--center screening-shell__header" *ngIf="!vm.isAuthenticated">
			<div class="o-container c-container">
				<div class="o-container">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v">
							<a href="javascript:void(0);" (click)="vm.goToPublicHome($event)" style="z-index: 10000; cursor: pointer; width: 124px; height: 33px;" class="c-header__logo c-logo c-logo--siffi-green c-logo--siffi-green@up-to-md"></a>
						</div>
					</div>
				</div>
				<nav class="c-nav c-nav--tab-bar screening-shell__lang-nav">
					<div class="o-container">
						<div class="c-nav__menu">
							<ul class="c-nav__list">
								<li class="c-nav__item">
									<siffi-language-picker [currentLocale]="vm.locale" (localeSelected)="vm.setLocale($event)"></siffi-language-picker>
								</li>
							</ul>
						</div>
					</div>
				</nav>
			</div>
		</div>

		<section class="screening">
			<nav class="screening__steps">
				<div *ngFor="let step of vm.steps" class="screening__step" [class.screening__step--active]="step.id === vm.activeMacro" [class.screening__step--done]="step.id < vm.activeMacro">
					<span>{{ step.id }}</span>
					<small>{{ step.label | translateUnauthenticated }}</small>
				</div>
			</nav>

			<div class="screening__container">
		<screening-platform *ngIf="vm.activeStep === 'platform'" (register)="vm.goToRegister()" (login)="vm.goToLogin()" (skip)="vm.continueWithoutAccount()"></screening-platform>
		<section class="screening__card" *ngIf="vm.activeStep === 'unavailable'">
			<p class="screening__lead">{{ 'Screening.Pilot.Platform.Unavailable' | translateUnauthenticated }}</p>
			<button type="button" class="c-button c-button--s12" (click)="vm.loadAvailability()">{{ 'Screening.Pilot.Platform.Retry' | translateUnauthenticated }}</button>
		</section>
		<p class="screening__error" *ngIf="vm.errorKey">{{ vm.errorKey | translateUnauthenticated }}</p>

		<section class="screening__card screening__card--consent" *ngIf="vm.activeStep === 'consent'">
			<p class="screening__eyebrow">{{ 'Screening.Pilot.Consent.Eyebrow' | translateUnauthenticated }}</p>
			<h2>{{ 'Screening.Pilot.Consent.Title' | translateUnauthenticated }}</h2>
			<p class="screening__lead">{{ 'Screening.Pilot.Consent.Lead' | translateUnauthenticated }}</p>

			<div class="screening__infodoc">
				<h3>{{ 'Screening.Pilot.Info.Title' | translateUnauthenticated }}</h3>
				<p class="screening__infodoc-subtitle">{{ 'Screening.Pilot.Info.Subtitle' | translateUnauthenticated }}</p>
				<p>{{ 'Screening.Pilot.Info.Intro' | translateUnauthenticated }}</p>

				<h4>{{ 'Screening.Pilot.Info.A.Title' | translateUnauthenticated }}</h4>
				<h5>{{ 'Screening.Pilot.Info.A1.Title' | translateUnauthenticated }}</h5>
				<p>{{ 'Screening.Pilot.Info.A1.P1' | translateUnauthenticated }}</p>
				<p>{{ 'Screening.Pilot.Info.A1.P2' | translateUnauthenticated }}</p>
				<p>{{ 'Screening.Pilot.Info.A1.P3' | translateUnauthenticated }}</p>
				<h5>{{ 'Screening.Pilot.Info.A2.Title' | translateUnauthenticated }}</h5>
				<ul>
					<li>{{ 'Screening.Pilot.Info.A2.1' | translateUnauthenticated }}</li>
					<li>{{ 'Screening.Pilot.Info.A2.2' | translateUnauthenticated }}</li>
					<li>{{ 'Screening.Pilot.Info.A2.3' | translateUnauthenticated }}</li>
					<li>{{ 'Screening.Pilot.Info.A2.4' | translateUnauthenticated }}</li>
				</ul>
				<p>{{ 'Screening.Pilot.Info.A2.P1' | translateUnauthenticated }}</p>
				<h5>{{ 'Screening.Pilot.Info.A3.Title' | translateUnauthenticated }}</h5>
				<p>{{ 'Screening.Pilot.Info.A3.P1' | translateUnauthenticated }}</p>
				<ul>
					<li>{{ 'Screening.Pilot.Info.A3.1' | translateUnauthenticated }}</li>
					<li>{{ 'Screening.Pilot.Info.A3.2' | translateUnauthenticated }}</li>
				</ul>
				<p>{{ 'Screening.Pilot.Info.A3.P2' | translateUnauthenticated }}</p>
				<h5>{{ 'Screening.Pilot.Info.A4.Title' | translateUnauthenticated }}</h5>
				<p>{{ 'Screening.Pilot.Info.A4.P1' | translateUnauthenticated }}</p>
				<h5>{{ 'Screening.Pilot.Info.A5.Title' | translateUnauthenticated }}</h5>
				<p>{{ 'Screening.Pilot.Info.A5.P1' | translateUnauthenticated }}</p>

				<h4>{{ 'Screening.Pilot.Privacy.Title' | translateUnauthenticated }}</h4>
				<p>{{ 'Screening.Pilot.Privacy.Intro' | translateUnauthenticated }}</p>
				<details class="screening__details">
					<summary>{{ 'Screening.Pilot.Privacy.B1.Title' | translateUnauthenticated }}</summary>
					<ul>
						<li>{{ 'Screening.Pilot.Privacy.B1.1' | translateUnauthenticated }}</li>
						<li>{{ 'Screening.Pilot.Privacy.B1.2' | translateUnauthenticated }}</li>
						<li>{{ 'Screening.Pilot.Privacy.B1.3' | translateUnauthenticated }}</li>
					</ul>
				</details>
				<details class="screening__details">
					<summary>{{ 'Screening.Pilot.Privacy.B2.Title' | translateUnauthenticated }}</summary>
					<p>{{ 'Screening.Pilot.Privacy.B2.P1' | translateUnauthenticated }}</p>
					<div class="screening__legal-table">
						<div class="screening__legal-row screening__legal-row--head">
							<span>{{ 'Screening.Pilot.Privacy.Table.Data' | translateUnauthenticated }}</span>
							<span>{{ 'Screening.Pilot.Privacy.Table.Purpose' | translateUnauthenticated }}</span>
							<span>{{ 'Screening.Pilot.Privacy.Table.Basis' | translateUnauthenticated }}</span>
						</div>
						<div class="screening__legal-row" *ngFor="let row of [1, 2, 3, 4]">
							<span>{{ ('Screening.Pilot.Privacy.Table.' + row + '.Data') | translateUnauthenticated }}</span>
							<span>{{ ('Screening.Pilot.Privacy.Table.' + row + '.Purpose') | translateUnauthenticated }}</span>
							<span>{{ ('Screening.Pilot.Privacy.Table.' + row + '.Basis') | translateUnauthenticated }}</span>
						</div>
					</div>
				</details>
				<details class="screening__details">
					<summary>{{ 'Screening.Pilot.Privacy.B3.Title' | translateUnauthenticated }}</summary>
					<ul>
						<li>{{ 'Screening.Pilot.Privacy.B3.1' | translateUnauthenticated }}</li>
						<li>{{ 'Screening.Pilot.Privacy.B3.2' | translateUnauthenticated }}</li>
						<li>{{ 'Screening.Pilot.Privacy.B3.3' | translateUnauthenticated }}</li>
					</ul>
				</details>
				<details class="screening__details"><summary>{{ 'Screening.Pilot.Privacy.B4.Title' | translateUnauthenticated }}</summary><p>{{ 'Screening.Pilot.Privacy.B4.P1' | translateUnauthenticated }}</p></details>
				<details class="screening__details"><summary>{{ 'Screening.Pilot.Privacy.B5.Title' | translateUnauthenticated }}</summary><p>{{ 'Screening.Pilot.Privacy.B5.P1' | translateUnauthenticated }}</p></details>
				<details class="screening__details"><summary>{{ 'Screening.Pilot.Privacy.B6.Title' | translateUnauthenticated }}</summary><p>{{ 'Screening.Pilot.Privacy.B6.P1' | translateUnauthenticated }}</p></details>
				<details class="screening__details">
					<summary>{{ 'Screening.Pilot.Privacy.B7.Title' | translateUnauthenticated }}</summary>
					<ul>
						<li>{{ 'Screening.Pilot.Privacy.B7.1' | translateUnauthenticated }}</li>
						<li>{{ 'Screening.Pilot.Privacy.B7.2' | translateUnauthenticated }}</li>
						<li>{{ 'Screening.Pilot.Privacy.B7.3' | translateUnauthenticated }}</li>
						<li>{{ 'Screening.Pilot.Privacy.B7.4' | translateUnauthenticated }}</li>
					</ul>
				</details>
				<details class="screening__details">
					<summary>{{ 'Screening.Pilot.Privacy.B8.Title' | translateUnauthenticated }}</summary>
					<ul>
						<li>{{ 'Screening.Pilot.Privacy.B8.1' | translateUnauthenticated }}</li>
						<li>{{ 'Screening.Pilot.Privacy.B8.2' | translateUnauthenticated }}</li>
					</ul>
				</details>
			</div>

			<p class="screening__lead screening__lead--tight"><strong>{{ 'Screening.Pilot.Consent.Decide' | translateUnauthenticated }}</strong></p>

				<div class="screening__consent" [class.is-yes]="vm.serviceConsent === true" [class.is-no]="vm.serviceConsent === false">
					<h3 class="screening__consent-title">{{ 'Screening.Pilot.Consent.Service.Title' | translateUnauthenticated }}</h3>
					<p>{{ 'Screening.Pilot.Consent.Service.Text' | translateUnauthenticated }}</p>
					<p class="screening__hint">{{ 'Screening.Pilot.Consent.Service.Hint' | translateUnauthenticated }}</p>
					<div class="screening__toggle screening__toggle--consent">
						<button type="button" [class.is-selected]="vm.serviceConsent === true" [class.is-yes]="vm.serviceConsent === true" (click)="vm.setServiceConsent(true)">
							<span class="screening__choice-dot"></span>
							{{ 'Screening.Pilot.Consent.Service.Yes' | translateUnauthenticated }}
					</button>
					<button type="button" [class.is-selected]="vm.serviceConsent === false" [class.is-no]="vm.serviceConsent === false" (click)="vm.setServiceConsent(false)">
							<span class="screening__choice-dot"></span>
							{{ 'Screening.Pilot.Consent.Service.No' | translateUnauthenticated }}
						</button>
					</div>
				</div>

				<div class="screening__consent" [class.is-yes]="vm.researchConsent === true" [class.is-no]="vm.researchConsent === false">
					<p>{{ 'Screening.Pilot.Consent.Research.Intro' | translateUnauthenticated }}</p>
					<h3 class="screening__consent-title">{{ 'Screening.Pilot.Consent.Research.Title' | translateUnauthenticated }}</h3>
					<p>{{ 'Screening.Pilot.Consent.Research.Text' | translateUnauthenticated }}</p>
					<div class="screening__toggle screening__toggle--consent">
						<button type="button" [class.is-selected]="vm.researchConsent === true" [class.is-yes]="vm.researchConsent === true" (click)="vm.setResearchConsent(true)">
							<span class="screening__choice-dot"></span>
							{{ 'Screening.Pilot.Consent.Research.Yes' | translateUnauthenticated }}
					</button>
					<button type="button" [class.is-selected]="vm.researchConsent === false" [class.is-no]="vm.researchConsent === false" (click)="vm.setResearchConsent(false)">
							<span class="screening__choice-dot"></span>
							{{ 'Screening.Pilot.Consent.Research.No' | translateUnauthenticated }}
						</button>
					</div>
				</div>

			<div class="screening__actions screening__actions--right">
				<button class="c-button c-button--s12 screening__confirm-button" [disabled]="vm.submitting || vm.serviceConsent === null || vm.researchConsent === null" (click)="vm.submitConsents()">{{ 'Screening.Pilot.Consent.Confirm' | translateUnauthenticated }}</button>
			</div>
			<p class="screening__hint screening__hint--standalone screening__hint--right">{{ vm.getConsentHintKey() | translateUnauthenticated }}</p>
		</section>

			<section class="screening__card" *ngIf="vm.activeStep === 'tier1-intro'">
				<p class="screening__eyebrow">{{ 'Screening.Pilot.Tier1.Eyebrow' | translateUnauthenticated }}</p>
				<h2>{{ 'Screening.Pilot.Tier1.Title' | translateUnauthenticated }}</h2>
				<p class="screening__lead">{{ 'Screening.Pilot.Tier1.Lead' | translateUnauthenticated }}</p>
				<div class="screening__actions screening__actions--between">
					<button class="c-button c-button--link screening__back-button" (click)="vm.go('consent')">{{ 'Screening.Pilot.Common.Back' | translateUnauthenticated }}</button>
					<button class="c-button c-button--s12" (click)="vm.startTier1()">{{ 'Screening.Pilot.Common.Start' | translateUnauthenticated }}</button>
				</div>
			</section>

			<section class="screening__card" *ngIf="vm.activeStep === 'tier1-question'">
				<p class="screening__eyebrow">
					<span class="screening__eyebrow-meta">{{ vm.getCurrentTier1QuestionNumber() }} / 10</span>
				</p>
				<div class="screening__qbar">
					<i [style.width.%]="vm.getTier1QuestionProgressPercent()"></i>
				</div>
				<div class="screening__guide" *ngIf="vm.getCurrentTier1Question().guideKey">
					{{ vm.getCurrentTier1Question().guideKey | translateUnauthenticated }}
				</div>
				<div class="screening__question">
					<h3>
						<span class="screening__qnum">{{ vm.getCurrentTier1QuestionNumber() }}</span>
						{{ vm.getCurrentTier1Question().questionKey | translateUnauthenticated }}
					</h3>
					<div class="screening__options" [class.screening__options--six]="vm.getCurrentTier1Question().options === 'who5'" *ngIf="vm.getCurrentTier1Question().options !== 'slider'">
						<button type="button" *ngFor="let option of vm.getCurrentTier1Options()" [class.is-selected]="vm.getCurrentTier1Answer() === option.value" (click)="vm.setCurrentTier1Answer(option.value)">
							<span class="screening__option-value">{{ option.value }}</span>
							<span class="screening__option-label">{{ option.label | translateUnauthenticated }}</span>
						</button>
					</div>
					<div class="screening__slider-wrap" *ngIf="vm.getCurrentTier1Question().options === 'slider'">
						<div class="screening__slider-value">{{ vm.wpai === null ? '-' : vm.wpai }}</div>
						<input class="screening__slider" type="range" min="0" max="10" step="1" [ngModel]="vm.wpai" (ngModelChange)="vm.setCurrentTier1Answer($event)">
						<div class="screening__slider-ends">
							<span>{{ 'Screening.Pilot.WPAI.Min' | translateUnauthenticated }}</span>
							<span>{{ 'Screening.Pilot.WPAI.Max' | translateUnauthenticated }}</span>
						</div>
						<div class="screening__slider-hint" *ngIf="vm.wpai === null">{{ 'Screening.Pilot.WPAI.Hint' | translateUnauthenticated }}</div>
					</div>
				</div>
				<div class="screening__actions screening__actions--between">
					<button class="c-button c-button--link screening__back-button" (click)="vm.goToPreviousTier1Question()">{{ 'Screening.Pilot.Common.Back' | translateUnauthenticated }}</button>
					<button class="c-button c-button--s12" [disabled]="vm.submitting || !vm.isCurrentTier1QuestionAnswered()" (click)="vm.advanceTier1Question()">{{ (vm.isLastTier1Question() ? 'Screening.Pilot.Common.Finish' : 'Screening.Pilot.Common.Next') | translateUnauthenticated }}</button>
				</div>
			</section>

		<section class="screening__card screening__card--violet" *ngIf="vm.activeStep === 'tier2-intro'">
			<p class="screening__eyebrow screening__eyebrow--violet">
				{{ 'Screening.Pilot.Tier2.Eyebrow' | translateUnauthenticated }}
			</p>
			<div class="screening__status screening__status--warn">
				<div class="screening__status-icon">+</div>
				<div class="screening__status-copy">
					<h2 class="screening__tier2-title">{{ 'Screening.Pilot.Tier2.Title' | translateUnauthenticated }}</h2>
				</div>
			</div>
			<p class="screening__tier2-copy">{{ 'Screening.Pilot.Tier2.Body.1' | translateUnauthenticated }}</p>
			<p class="screening__tier2-copy">{{ 'Screening.Pilot.Tier2.Body.2' | translateUnauthenticated }}</p>
			<div class="screening__actions">
				<button class="c-button c-button--s12 screening__violet-button" (click)="vm.startTier2()">{{ 'Screening.Pilot.Tier2.Button' | translateUnauthenticated }}</button>
			</div>
		</section>

		<section class="screening__card" *ngIf="vm.activeStep === 'phq9'">
			<p class="screening__eyebrow">
				{{ 'Screening.Pilot.Tier2.Eyebrow' | translateUnauthenticated }}
				<span class="screening__eyebrow-meta">{{ vm.getTier2StageCounter() }}</span>
			</p>
			<div class="screening__qbar">
				<i [style.width.%]="vm.getTier2QuestionProgressPercent()"></i>
			</div>
			<div class="screening__guide">
				{{ 'Screening.Pilot.PHQGAD.Guide' | translateUnauthenticated }}
			</div>
			<div class="screening__question">
				<h3>
					<span class="screening__qnum">{{ vm.getCurrentTier2QuestionNumber() }}</span>
					{{ vm.getCurrentTier2Question().questionKey | translateUnauthenticated }}
				</h3>
				<div class="screening__options">
					<button type="button" *ngFor="let option of vm.frequencyOptions" [class.is-selected]="vm.getCurrentTier2Answer() === option.value" (click)="vm.setCurrentTier2Answer(option.value)">
						<span class="screening__option-value">{{ option.value }}</span>
						<span class="screening__option-label">{{ option.label | translateUnauthenticated }}</span>
					</button>
				</div>
			</div>
			<div class="screening__actions screening__actions--between">
				<button class="c-button c-button--link screening__back-button" (click)="vm.goToPreviousTier2Question()">{{ 'Screening.Pilot.Common.Back' | translateUnauthenticated }}</button>
				<button class="c-button c-button--s12" [disabled]="vm.submitting || !vm.isCurrentTier2QuestionAnswered()" (click)="vm.advanceTier2Question()">{{ (vm.isLastTier2Question() ? 'Screening.Pilot.Common.Finish' : 'Screening.Pilot.Common.Next') | translateUnauthenticated }}</button>
			</div>
		</section>

		<section class="screening__card" *ngIf="vm.activeStep === 'crisis'">
			<p class="screening__eyebrow screening__eyebrow--critical">
				<span class="screening__eyebrow-dot screening__eyebrow-dot--critical">6</span>
				{{ 'Screening.Pilot.Crisis.Eyebrow' | translateUnauthenticated }}
			</p>
			<div class="screening__status screening__status--critical">
				<div class="screening__status-icon screening__status-icon--critical">!</div>
				<div class="screening__status-copy">
					<h2 class="screening__crisis-title">{{ 'Screening.Pilot.Crisis.Title' | translateUnauthenticated }}</h2>
					<p class="screening__lead screening__lead--critical">{{ 'Screening.Pilot.Crisis.Lead' | translateUnauthenticated }}</p>
				</div>
			</div>
			<ol class="screening__crisis-list">
				<li *ngFor="let contact of vm.crisisContacts; let i = index">
					<span class="screening__crisis-num">{{ i + 1 }}</span>
					<div class="screening__crisis-copy">{{ contact.key | translateUnauthenticated }}</div>
				</li>
			</ol>
			<p class="screening__note">{{ 'Screening.Pilot.Crisis.Note' | translateUnauthenticated }}</p>
			<div class="screening__actions">
				<button class="c-button c-button--s12" (click)="vm.continueFromCrisis()">{{ 'Screening.Pilot.Common.Continue' | translateUnauthenticated }}</button>
			</div>
		</section>

		<section class="screening__card" *ngIf="vm.activeStep === 'result'">
			<p class="screening__eyebrow screening__eyebrow--violet">
				<span class="screening__eyebrow-dot screening__eyebrow-dot--violet">7</span>
				{{ 'Screening.Pilot.Result.Eyebrow' | translateUnauthenticated }}
			</p>
			<div class="screening__status screening__status--result">
				<div class="screening__status-icon screening__status-icon--violet">i</div>
				<div class="screening__status-copy">
					<h2 class="screening__result-title">{{ 'Screening.Pilot.Result.Title' | translateUnauthenticated }}</h2>
					<p class="screening__lead screening__lead--result">{{ 'Screening.Pilot.Result.Lead' | translateUnauthenticated }}</p>
				</div>
			</div>
				<div class="screening__scores" *ngIf="vm.result">
					<div class="screening__score screening__score--result">
						<small>{{ 'Screening.Pilot.Result.WHO5' | translateUnauthenticated }}</small>
						<strong>{{ vm.result.who5Total }} / 100</strong>
						<span>{{ ('Screening.Pilot.Result.WHO5.Band.' + vm.result.who5Band) | translateUnauthenticated }}</span>
						<div class="screening__who5-bar">
							<i [style.width.%]="vm.result.who5Total"></i>
						</div>
					</div>
					<div class="screening__score screening__score--result">
						<small>{{ 'Screening.Pilot.Result.PHQ9' | translateUnauthenticated }}</small>
						<strong>{{ vm.result.phq9Total }} / 27</strong>
					<span>{{ ('Screening.Pilot.Band.' + vm.result.phq9Band) | translateUnauthenticated }}</span>
				</div>
				<div class="screening__score screening__score--result">
					<small>{{ 'Screening.Pilot.Result.GAD7' | translateUnauthenticated }}</small>
					<strong>{{ vm.result.gad7Total }} / 21</strong>
						<span>{{ ('Screening.Pilot.Band.' + vm.result.gad7Band) | translateUnauthenticated }}</span>
					</div>
				</div>
				<details class="screening__details screening__details--result">
					<summary>{{ 'Screening.Pilot.Result.WHO5.Details.Title' | translateUnauthenticated }}</summary>
					<ul>
						<li>{{ 'Screening.Pilot.Result.WHO5.Details.1' | translateUnauthenticated }}</li>
						<li>{{ 'Screening.Pilot.Result.WHO5.Details.2' | translateUnauthenticated }}</li>
						<li>{{ 'Screening.Pilot.Result.WHO5.Details.3' | translateUnauthenticated }}</li>
						<li>{{ 'Screening.Pilot.Result.WHO5.Details.4' | translateUnauthenticated }}</li>
						<li>{{ 'Screening.Pilot.Result.WHO5.Details.5' | translateUnauthenticated }}</li>
					</ul>
				</details>
				<p class="screening__result-note">{{ 'Screening.Pilot.Result.Note' | translateUnauthenticated }}</p>
			<button class="c-button c-button--s12 screening__download-button" *ngIf="vm.result" (click)="vm.downloadResults()">{{ 'Screening.Pilot.Result.Download' | translateUnauthenticated }}</button>
			<div class="screening__next screening__account-pitch" *ngIf="vm.serviceConsent === true && vm.researchConsent === false">
				<p class="screening__account-eyebrow">
					<span>4</span>
					{{ 'Screening.Pilot.Result.ServiceOnly.Eyebrow' | translateUnauthenticated }}
				</p>
				<section class="screening__account-intro">
					<div class="screening__account-heading">
						<h3>{{ 'Screening.Pilot.Result.ServiceOnly.Title' | translateUnauthenticated }}</h3>
						<strong>{{ 'Screening.Pilot.Result.ServiceOnly.Badge' | translateUnauthenticated }}</strong>
					</div>
					<p>{{ 'Screening.Pilot.Result.ServiceOnly.Lead' | translateUnauthenticated }}</p>
				</section>
				<ul class="screening__account-benefits">
					<li>
						<span class="screening__account-icon">
							<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
						</span>
						<div>
							<h4>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.1.Title' | translateUnauthenticated }}</h4>
							<p>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.1.Text' | translateUnauthenticated }}</p>
						</div>
					</li>
					<li>
						<span class="screening__account-icon">
							<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z"></path><path d="M8 7h8M8 11h6"></path></svg>
						</span>
						<div>
							<h4>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.2.Title' | translateUnauthenticated }}</h4>
							<p>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.2.Text' | translateUnauthenticated }}</p>
						</div>
					</li>
					<li>
						<span class="screening__account-icon">
							<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 3v18h18"></path><path d="M7 15l4-4 3 3 5-6"></path></svg>
						</span>
						<div>
							<h4>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.3.Title' | translateUnauthenticated }}</h4>
							<p>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.3.Text' | translateUnauthenticated }}</p>
						</div>
					</li>
				</ul>
				<div class="screening__account-trust">
					<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4"></path></svg>
					<span>{{ 'Screening.Pilot.Result.ServiceOnly.Trust' | translateUnauthenticated }}</span>
				</div>
				<div class="screening__account-actions">
					<button class="c-button c-button--s12 screening__result-button" (click)="vm.goToRegister()">{{ 'Screening.Pilot.Result.ServiceOnly.Register' | translateUnauthenticated }}</button>
					<button class="c-button c-button--link screening__result-link" (click)="vm.goToLogin()">{{ 'Screening.Pilot.Result.ServiceOnly.Login' | translateUnauthenticated }}</button>
				</div>
			</div>
			<div class="screening__next" *ngIf="vm.serviceConsent !== false && vm.researchConsent !== false">
				<h3>{{ 'Screening.Pilot.Result.Next.Title' | translateUnauthenticated }}</h3>
				<p>{{ 'Screening.Pilot.Result.Next.Lead' | translateUnauthenticated }}</p>
				<ul class="screening__cta-list">
					<li>
						<span class="screening__cta-icon">💾</span>
						<div>{{ 'Screening.Pilot.Result.Next.1' | translateUnauthenticated }}</div>
					</li>
					<li>
						<span class="screening__cta-icon">🗓️</span>
						<div>{{ 'Screening.Pilot.Result.Next.2' | translateUnauthenticated }}</div>
					</li>
					<li>
						<span class="screening__cta-icon">🧰</span>
						<div>{{ 'Screening.Pilot.Result.Next.3' | translateUnauthenticated }}</div>
					</li>
				</ul>
				<button class="c-button c-button--s12 screening__result-button" (click)="vm.goToRegister()">{{ 'Screening.Pilot.Result.Register' | translateUnauthenticated }}</button>
				<button class="c-button c-button--link screening__result-link" (click)="vm.goToLogin()">{{ 'Screening.Pilot.Result.Login' | translateUnauthenticated }}</button>
				<button class="c-button c-button--link screening__result-link" *ngIf="vm.canOfferLinkageCode()" (click)="vm.openLinkageCode('result')">{{ 'Screening.Pilot.Result.Anonymous' | translateUnauthenticated }}</button>
			</div>
			<div class="screening__next" *ngIf="vm.serviceConsent === false">
				<h3>{{ 'Screening.Pilot.Result.ResearchOnly.Title' | translateUnauthenticated }}</h3>
				<p>{{ 'Screening.Pilot.Result.ResearchOnly.Lead' | translateUnauthenticated }}</p>
				<button class="c-button c-button--link screening__result-link" *ngIf="vm.canOfferLinkageCode()" (click)="vm.openLinkageCode('result')">{{ 'Screening.Pilot.Result.Anonymous' | translateUnauthenticated }}</button>
			</div>
		</section>

		<section class="screening__card" *ngIf="vm.activeStep === 'thank-you'">
			<div *ngIf="vm.serviceConsent !== false; else researchOnlyThanks">
				<p class="screening__account-eyebrow">
					{{ 'Screening.Pilot.Thanks.Eyebrow' | translateUnauthenticated }}
				</p>

				<section class="screening__account-intro screening__account-intro--plain">
					<div class="screening__account-heading">
						<h3>{{ 'Screening.Pilot.Result.ServiceOnly.Title' | translateUnauthenticated }}</h3>
						<strong>{{ 'Screening.Pilot.Result.ServiceOnly.Badge' | translateUnauthenticated }}</strong>
					</div>
					<p>{{ 'Screening.Pilot.Result.ServiceOnly.Lead' | translateUnauthenticated }}</p>
				</section>
				<ul class="screening__account-benefits">
					<li>
						<span class="screening__account-icon">
							<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
						</span>
						<div>
							<h4>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.1.Title' | translateUnauthenticated }}</h4>
							<p>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.1.Text' | translateUnauthenticated }}</p>
						</div>
					</li>
					<li>
						<span class="screening__account-icon">
							<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z"></path><path d="M8 7h8M8 11h6"></path></svg>
						</span>
						<div>
							<h4>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.2.Title' | translateUnauthenticated }}</h4>
							<p>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.2.Text' | translateUnauthenticated }}</p>
						</div>
					</li>
					<li>
						<span class="screening__account-icon">
							<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 3v18h18"></path><path d="M7 15l4-4 3 3 5-6"></path></svg>
						</span>
						<div>
							<h4>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.3.Title' | translateUnauthenticated }}</h4>
							<p>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.3.Text' | translateUnauthenticated }}</p>
						</div>
					</li>
				</ul>
				<div class="screening__account-trust">
					<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4"></path></svg>
					<span>{{ 'Screening.Pilot.Result.ServiceOnly.Trust' | translateUnauthenticated }}</span>
				</div>
				<div class="screening__account-actions">
					<button class="c-button c-button--s12 screening__result-button" (click)="vm.goToRegister()">{{ 'Screening.Pilot.Result.ServiceOnly.Register' | translateUnauthenticated }}</button>
					<button class="c-button c-button--link screening__result-link" (click)="vm.goToLogin()">{{ 'Screening.Pilot.Result.ServiceOnly.Login' | translateUnauthenticated }}</button>
				</div>
				<div class="screening__account-foot">
					<span>{{ 'Screening.Pilot.Thanks.FollowUp' | translateUnauthenticated }}</span>
					<button class="c-button c-button--link screening__result-link" *ngIf="vm.canOfferLinkageCode()" (click)="vm.openLinkageCode('thank-you')">{{ 'Screening.Pilot.Thanks.Anonymous' | translateUnauthenticated }}</button>
				</div>
			</div>
			<ng-template #researchOnlyThanks>
				<p class="screening__eyebrow">{{ 'Screening.Pilot.Thanks.Eyebrow' | translateUnauthenticated }}</p>
				<h2>{{ 'Screening.Pilot.Platform.ThanksTitle' | translateUnauthenticated }}</h2>
				<p class="screening__lead">{{ 'Screening.Pilot.Platform.ThanksLead' | translateUnauthenticated }}</p>
			</ng-template>
		</section>

		<section class="screening__card" *ngIf="vm.activeStep === 'end'">
			<p class="screening__eyebrow">{{ 'Screening.Pilot.End.Eyebrow' | translateUnauthenticated }}</p>
			<h2>{{ 'Screening.Pilot.End.Title' | translateUnauthenticated }}</h2>
			<p class="screening__lead">{{ 'Screening.Pilot.End.Lead' | translateUnauthenticated }}</p>
		</section>

		<section class="screening__card" *ngIf="vm.activeStep === 'auth'">
			<div class="screening__next screening__account-pitch screening__account-pitch--auth" *ngIf="vm.serviceConsent === true && vm.researchConsent === false; else defaultAuthPrompt">
				<p class="screening__account-eyebrow">
					<span>4</span>
					{{ 'Screening.Pilot.Result.ServiceOnly.Eyebrow' | translateUnauthenticated }}
				</p>
				<section class="screening__account-intro">
					<div class="screening__account-heading">
						<h3>{{ 'Screening.Pilot.Result.ServiceOnly.Title' | translateUnauthenticated }}</h3>
						<strong>{{ 'Screening.Pilot.Result.ServiceOnly.Badge' | translateUnauthenticated }}</strong>
					</div>
					<p>{{ 'Screening.Pilot.Result.ServiceOnly.Lead' | translateUnauthenticated }}</p>
				</section>
				<ul class="screening__account-benefits">
					<li>
						<span class="screening__account-icon">
							<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
						</span>
						<div>
							<h4>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.1.Title' | translateUnauthenticated }}</h4>
							<p>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.1.Text' | translateUnauthenticated }}</p>
						</div>
					</li>
					<li>
						<span class="screening__account-icon">
							<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z"></path><path d="M8 7h8M8 11h6"></path></svg>
						</span>
						<div>
							<h4>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.2.Title' | translateUnauthenticated }}</h4>
							<p>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.2.Text' | translateUnauthenticated }}</p>
						</div>
					</li>
					<li>
						<span class="screening__account-icon">
							<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 3v18h18"></path><path d="M7 15l4-4 3 3 5-6"></path></svg>
						</span>
						<div>
							<h4>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.3.Title' | translateUnauthenticated }}</h4>
							<p>{{ 'Screening.Pilot.Result.ServiceOnly.Benefit.3.Text' | translateUnauthenticated }}</p>
						</div>
					</li>
				</ul>
				<div class="screening__account-trust">
					<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4"></path></svg>
					<span>{{ 'Screening.Pilot.Result.ServiceOnly.Trust' | translateUnauthenticated }}</span>
				</div>
				<div class="screening__account-actions">
					<button class="c-button c-button--s12 screening__result-button" (click)="vm.goToRegister()">{{ 'Screening.Pilot.Result.ServiceOnly.Register' | translateUnauthenticated }}</button>
					<button class="c-button c-button--link screening__result-link" (click)="vm.goToLogin()">{{ 'Screening.Pilot.Result.ServiceOnly.Login' | translateUnauthenticated }}</button>
				</div>
			</div>
			<ng-template #defaultAuthPrompt>
				<p class="screening__eyebrow">{{ 'Screening.Pilot.Auth.Eyebrow' | translateUnauthenticated }}</p>
				<h2>{{ 'Screening.Pilot.Auth.Title' | translateUnauthenticated }}</h2>
				<p class="screening__lead">{{ 'Screening.Pilot.Auth.Lead' | translateUnauthenticated }}</p>
				<div class="screening__actions">
					<button class="c-button c-button--s12" (click)="vm.goToRegister()">{{ 'Screening.Pilot.Auth.Create' | translateUnauthenticated }}</button>
					<button class="c-button c-button--link" (click)="vm.goToLogin()">{{ 'Screening.Pilot.Auth.Login' | translateUnauthenticated }}</button>
					<button class="c-button c-button--link screening__result-link" *ngIf="vm.canOfferLinkageCode()" (click)="vm.openLinkageCode('auth')">{{ 'Screening.Pilot.Auth.Anonymous' | translateUnauthenticated }}</button>
				</div>
			</ng-template>
		</section>

		<section class="screening__card" *ngIf="vm.activeStep === 'linkcode'">
			<p class="screening__eyebrow">{{ 'Screening.Pilot.Linkage.Eyebrow' | translateUnauthenticated }}</p>
			<h2>{{ 'Screening.Pilot.Linkage.Intro' | translateUnauthenticated }}</h2>
			<p class="screening__lead">{{ 'Screening.Pilot.Linkage.Sub' | translateUnauthenticated }}</p>
			<div class="screening__form-card">
				<div class="screening__field">
					<label class="screening__field-label" for="screeningLinkageQuestion">{{ 'Screening.Pilot.Linkage.Question.Label' | translateUnauthenticated }}</label>
					<select id="screeningLinkageQuestion" class="screening__select" [(ngModel)]="vm.linkageQuestionId">
						<option *ngFor="let question of vm.linkageQuestions" [value]="question.id">{{ question.label | translateUnauthenticated }}</option>
					</select>
				</div>
				<div class="screening__field">
					<label class="screening__field-label" for="screeningLinkageAnswer">{{ 'Screening.Pilot.Linkage.Answer.Label' | translateUnauthenticated }}</label>
					<input id="screeningLinkageAnswer" class="screening__input" type="text" [(ngModel)]="vm.linkageAnswer" [placeholder]="'Screening.Pilot.Linkage.Answer.Placeholder' | translateUnauthenticated">
				</div>
			</div>
			<p class="screening__hint screening__hint--standalone">{{ 'Screening.Pilot.Linkage.Hint' | translateUnauthenticated }}</p>
			<div class="screening__actions screening__actions--between">
				<button class="c-button c-button--link screening__back-button" (click)="vm.goBackFromLinkageCode()">{{ 'Screening.Pilot.Common.Back' | translateUnauthenticated }}</button>
				<button class="c-button c-button--s12" [disabled]="vm.submitting || !vm.isLinkageAnswerValid()" (click)="vm.submitLinkageCode()">{{ 'Screening.Pilot.Common.Continue' | translateUnauthenticated }}</button>
			</div>
		</section>

		<section class="screening__card" *ngIf="vm.activeStep === 'linkdone'">
			<h2>{{ 'Screening.Pilot.Platform.ThanksTitle' | translateUnauthenticated }}</h2>
			<p class="screening__lead">{{ 'Screening.Pilot.Platform.ThanksLead' | translateUnauthenticated }}</p>
		</section>
			</div>
		</section>
	</div>

	<div class="c-footer u-hidden@up-to-md screening-shell__footer">
		<div class="o-container">
			<div class="o-grid o-grid--wrap o-grid--center-v">
				<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--o2@md-and-up">
					<a href="javascript:void(0);" class="c-footer__logo c-logo c-logo--main c-logo--siffi-white" (click)="vm.goToPublicHome($event)"></a>
				</div>
				<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up o-grid__cell--o3@md-and-up c-footer__cell">
					<ul class="c-list c-footer__list">
						<li class="c-list__item" *ngFor="let link of vm.publicLinks">
							<a [href]="link.link" class="c-list__link c-text c-footer__siffi-text">{{ link.key | translateUnauthenticated }}</a>
						</li>
					</ul>
				</div>
				<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up c-footer__cell o-grid__cell--o1@md-and-up">
					<p class="c-text c-footer__text c-footer__siffi-text">{{ 'Address.Siffi' | translateUnauthenticated }}</p>
					<p class="c-text c-footer__text c-footer__siffi-text">+372 501 9568</p>
					<a href="mailto:contact@siffi.com" class="c-text c-footer__text c-footer__siffi-text">contact&#64;siffi.com</a>
				</div>
			</div>
		</div>
	</div>
</section>

<ng-template #loadingState>
	<section class="screening-shell screening-shell--loading">
		<div class="screening-shell__bleed">
			<section class="screening screening--loading">
		<p>{{ 'Screening.Pilot.Loading' | translateUnauthenticated }}</p>
			</section>
		</div>
	</section>
</ng-template>
